import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import React from "react";

interface BankAccountSidePanelDetailsProps {
  bankAccount: server.dto.BankAccount
}

export const BankAccountSidePanelDetails = (props: BankAccountSidePanelDetailsProps) => {
  return <SidePanelDetailSectionTemplate
    isInPageEditable={false}
    onValueChanged={() => { }}
    fields={[{
      key: "title",
      label: RESX.GeneralLabels.InternalTitle,
      render: () => <>{props.bankAccount.title}</>
    }, {
      key: "format",
      label: RESX.BankAccount.Format,
      render: () => <>{serverReference.bankAccountFormats.find(f => f.value === props.bankAccount.format)?.text}</>
    }, {
      key: "beneficiaryName",
      label: RESX.BankAccount.BeneficiaryName,
      render: () => <>{props.bankAccount.beneficiaryName}</>
    }, {
      key: "abaRoutingNumber",
      label: RESX.BankAccount.RoutingNumber,
      isEmpty: !props.bankAccount.abaRoutingNumber,
      render: () => <>{props.bankAccount.abaRoutingNumber}</>
    }, {
      key: "institutionNumber",
      label: RESX.BankAccount.InstitutionNumber,
      isEmpty: !props.bankAccount.institutionNumber,
      render: () => <>{props.bankAccount.institutionNumber}</>
    }, {
      key: "accountNumber",
      label: RESX.BankAccount.AccountNumber,
      isEmpty: !props.bankAccount.accountNumber,
      render: () => <>{props.bankAccount.accountNumber}</>
    }, {
      key: "transitNumber",
      label: RESX.BankAccount.TransitNumber,
      isEmpty: !props.bankAccount.transitNumber,
      render: () => <>{props.bankAccount.transitNumber}</>
    }, {
      key: "bsbCode",
      label: RESX.BankAccount.BsbCode,
      isEmpty: !props.bankAccount.bsbCode,
      render: () => <>{props.bankAccount.bsbCode}</>
    }, {
      key: "ibanNumber",
      label: RESX.BankAccount.IbanNumber,
      isEmpty: !props.bankAccount.ibanNumber,
      render: () => <>{props.bankAccount.ibanNumber}</>
    }, {
      key: "sortCode",
      label: RESX.BankAccount.SortCode,
      isEmpty: !props.bankAccount.sortCode,
      render: () => <>{props.bankAccount.sortCode}</>
    }, {
      key: "swiftCode",
      label: RESX.BankAccount.SwiftCode,
      isEmpty: !props.bankAccount.swiftCode,
      render: () => <>{props.bankAccount.swiftCode}</>
    }, {
      key: "bankAddress",
      label: RESX.BankAccount.Bank,
      isEmpty: !props.bankAccount.bankAddress,
      render: () => <>{props.bankAccount.bankAddress}</>
    }, {
      key: "branchName",
      label: RESX.BankAccount.BranchName,
      isEmpty: !props.bankAccount.branchName,
      render: () => <>{props.bankAccount.branchName}</>
    }, {
      key: "branchCode",
      label: RESX.BankAccount.BranchCode,
      isEmpty: !props.bankAccount.branchCode,
      render: () => <>{props.bankAccount.branchCode}</>
    }, {
      key: "memo",
      label: RESX.BankAccount.Memo,
      isEmpty: !props.bankAccount.memo,
      render: () => <>{props.bankAccount.memo}</>
    }]}
  />
}